export default "/images/724e998d942e7b708fb68a5aa5316e61.png";